import React, { useEffect, useState } from "react";
import Card from "components/card";

import FeesCard from "./FeesCard";

import {
  Tabs,
  TabsHeader,
  TabsBody,
  // Tab,
  TabPanel,
  Spinner,
} from "@material-tailwind/react";
import { getAllTcpsApi } from "api/filtersData";
import {
  getAllDgCompanyFeesApi,
  getAllTcpCompanyFeesApi,
  getAllCompanyFeesCategoryApi,
} from "api/companyFees";
import { getAllOperatorsApi } from "api/filtersData";
import { getCookie } from "utils/cookies";

function FeesListDG({ accessList, isAdmin }) {
  const [isLoading, setIsLoading] = useState(false);

  const [listOfTcp, setListOfTcp] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [companyFeesCategories, setCompanyFeesCategories] = useState([]);

  const [TabsData, setTabsData] = useState([]);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [filtredObject, setFiltredObject] = useState({
    typeOfOp: "ALL",
    responsable: "",
    cvValidationStaus: "",
    fdValidationStatus: "",
    tlValidationStatus: "",
    evenementsValidationStatus: "",
    avocatValidationStatus: "",
    dynamicValidationStatus: "N", // non-admin default = "En cours"
    dgValidationStatus: "",
    selectedFromDate: `${selectedYear}-01-01`,
    selectedToDate: `${selectedYear}-12-31`,
  });
  // CV FD TL-FTL EVENEMENTS AVOCAT

  useEffect(() => {
    getFilterData();
    getAllCompanyFeesCategory();
    getInitialData(filtredObject);
  }, [accessList, isAdmin, filtredObject]);

  const getFilterData = async () => {
    try {
      const response = await getAllOperatorsApi();
      setListOfTcp(response);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllCompanyFeesCategory = async () => {
    try {
      const response = await getAllCompanyFeesCategoryApi();
      setCompanyFeesCategories(response);
    } catch (err) {
      console.log(err);
    }
  };

  const canAccessDynamicCategory = (categoryId) =>
    accessList.DynamicCategories === "ALL" ||
    (accessList.DynamicCategories || []).includes(categoryId);

  const handleShowToast = async () => {
    getInitialData(filtredObject);
  };

  const handleShowTcpToast = async () => {
    getInitialData(filtredObject);
  };

  const getInitialData = async (filtredObjectData) => {
    try {
      const normalizedFilters = {
        ...filtredObjectData,
        typeOfOp:
          filtredObjectData.typeOfOp === "ALL" ? "" : filtredObjectData.typeOfOp,
        // Non-admin only has the dynamic status filter, admin only the DG one:
        // never combine them.
        ...(isAdmin
          ? { dynamicValidationStatus: "" }
          : { dgValidationStatus: "" }),
      };

      if (isAdmin) {
        setIsLoading(true);

        // this route only ever shows fees that already passed first-level
        // validation (cv/fd/tl/evenements/avocat/dynamicValidationStatus:
        // "V") — that filter is hardcoded server-side in getAllCompanyFees2DG
        const response = await getAllDgCompanyFeesApi(normalizedFilters);
        const dynamicOnly = response.filter((el) => el.typeOfOp === "DYNAMIC");
        setTableData(dynamicOnly);

        setTabsData([
          {
            label: "Maroc",
            value: "Morocco",
            desc: (
              <FeesCard
                tableData={dynamicOnly}
                accessList={accessList}
                isAdmin={true}
                showToast={handleShowToast}
              />
            ),
          },
        ]);
      } else if (!isAdmin) {
        setIsLoading(true);

        const response = await getAllTcpCompanyFeesApi(normalizedFilters);

        // Operators only see/validate dynamic fees of their own categories:
        // feesCategory.tcp (from companyfeescategories) must be the logged
        // user, not the fee's responsable. Role access still applies.
        // Static legacy types (CV/FD/TL/EVENEMENTS/AVOCAT) are no longer
        // shown at all — dynamic fees only.
        const loggedUserID = getCookie("3F2Mb2pJ1YRro5Z4");

        const filtredResponse = response.filter((el) => {
          if (el.typeOfOp !== "DYNAMIC") return false;

          const categoryTcp =
            el.feesCategory?.tcp?._id || el.feesCategory?.tcp;
          if (categoryTcp !== loggedUserID) return false;

          return (
            accessList.DynamicCategories === "ALL" ||
            (accessList.DynamicCategories || []).includes(
              el.feesCategory?._id || el.feesCategory
            )
          );
        });

        setTableData(filtredResponse);

        setTabsData([
          {
            label: "Maroc",
            value: "Morocco",
            desc: (
              <FeesCard
                tableData={filtredResponse}
                accessList={accessList}
                isAdmin={false}
                typeOfOp={filtredObjectData.typeOfOp}
                showToast={handleShowTcpToast}
              />
            ),
          },
        ]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFiltersInputChange = (e) => {
    const { name, value } = e.target;
    setFiltredObject((prevInputFilterValue) => ({
      ...prevInputFilterValue,
      [name]: value,
    }));

    if (name === "typeOfOp") filtredObject.typeOfOp = value;

    if (name === "responsable") filtredObject.responsable = value;

    if (name === "cvValidationStaus") filtredObject.cvValidationStaus = value;

    if (name === "fdValidationStatus") filtredObject.fdValidationStatus = value;

    if (name === "tlValidationStatus") filtredObject.tlValidationStatus = value;

    if (name === "evenementsValidationStatus")
      filtredObject.evenementsValidationStatus = value;

    if (name === "avocatValidationStatus")
      filtredObject.avocatValidationStatus = value;

    if (name === "dynamicValidationStatus")
      filtredObject.dynamicValidationStatus = value;

    if (name === "dgValidationStatus") filtredObject.dgValidationStatus = value;

    // refetch is triggered by the useEffect on [filtredObject] (no double fetch)
  };

  const handleYearFiltersInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedYear(value);

    setFiltredObject((prevState) => ({
      ...prevState,
      selectedFromDate: `${value}-01-01`,
      selectedToDate: `${value}-12-31`,
    }));
    // refetch is triggered by the useEffect on [filtredObject]
  };

  return (
    <div>
      {isLoading ? (
        <div className="flex w-full items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <Card extra={"w-full pb-10 p-4 h-full"}>
          <header className="relative flex items-center justify-between">
            <div></div>
          </header>

          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-4">
            <div>
              <small className="text-sm font-medium text-gray-600 dark:text-white">
                Filtrer par statut
              </small>
              {isAdmin ? (
                <div>
                  <select
                    label="select Version"
                    className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                    name="dgValidationStatus"
                    value={filtredObject.dgValidationStatus}
                    onChange={handleFiltersInputChange}
                  >
                    <option value="">Tout</option>
                    <option value="V">Validée</option>
                    <option value="A">Annulée</option>
                    <option value="N">En cours</option>
                  </select>
                </div>
              ) : (
                <div>
                    <select
                      label="select Version"
                      className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                      name="dynamicValidationStatus"
                      value={filtredObject.dynamicValidationStatus}
                      onChange={handleFiltersInputChange}
                    >
                      <option value="">Tout</option>
                      <option value="V">Validée</option>
                      <option value="A">Annulée</option>
                      <option value="N">En cours</option>
                    </select>
                </div>
              )}
            </div>
            <div>
              <small className="text-sm font-medium text-gray-600 dark:text-white">
                Filtrer par TCP
              </small>
              <div>
                <select
                  label="select Version"
                  className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                  name="responsable"
                  value={filtredObject.responsable}
                  onChange={handleFiltersInputChange}
                >
                  <option value="">Tout</option>
                  {listOfTcp.map((el) => (
                    <option value={el._id}>{el.Name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div>
              <small className="text-sm font-medium text-gray-600 dark:text-white">
                Filtrer par type d'opération
              </small>
              <div>
                <select
                  label="select Version"
                  className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                  name="typeOfOp"
                  value={filtredObject.typeOfOp}
                  onChange={handleFiltersInputChange}
                >
                  <option value="ALL">Tous</option>
                  {companyFeesCategories
                    .filter((el) => canAccessDynamicCategory(el._id))
                    .map((el) => (
                      <option key={el._id} value={`DYNAMIC:${el._id}`}>
                        {el.category}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div>
              <small className="text-sm font-medium text-gray-600 dark:text-white">
                Filtrer par année
              </small>
              <div>
                <input
                  type="number"
                  id=""
                  placeholder=""
                  className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                  name="Produit"
                  value={selectedYear}
                  onChange={handleYearFiltersInputChange}
                />
              </div>
            </div>
          </div>

          <div
            className="mt-8 overflow-x-scroll xl:overflow-x-hidden"
            style={{ height: "60vh", overflowY: "scroll" }}
          >
            <Tabs value="Morocco">
              <TabsHeader className="flex flex-col md:flex-row"></TabsHeader>
              <TabsBody>
                {TabsData.map(({ value, desc }) => (
                  <TabPanel key={value} value={value}>
                    {desc}
                  </TabPanel>
                ))}
              </TabsBody>
            </Tabs>
          </div>
        </Card>
      )}
    </div>
  );
}

export default FeesListDG;

// FeesListDG
